import { embedDashboard } from "@superset-ui/embedded-sdk";
import { useEffect } from 'react';
import { supersetService } from '../../../services/superset-service';
import { Config } from "@/core/config/config";


const SUPERSET_DOMAIN = Config.VITE_APP_SUPERSET_URL;


export default function LiveSalesDashboard() {

    useEffect(() => {
        embedDashboard({
            id: "2d8f88d0-2b06-4710-83e0-e10b87aaa27b",
            supersetDomain: SUPERSET_DOMAIN!,
            mountPoint: document.querySelector("#superset-container")!, 
            fetchGuestToken: () => supersetService.getLiveSalesDashboard()
                .then((response) => response.data.token),
            dashboardUiConfig: { hideTitle: true, hideChartControls: false },

        });
    }, [])
    return (

        <div id="superset-container" className="embedded-superset">

        </div>

    );
}